export default function Footer() {
  const cols = [
    {
      title: "栏目图鉴",
      links: [
        { label: "明星名场面", href: "#archive" },
        { label: "网红现场", href: "#archive" },
        { label: "综艺高能", href: "#archive" },
        { label: "剧组趣闻", href: "#archive" },
      ],
    },
    {
      title: "关于我们",
      links: [
        { label: "圈子生态", href: "#circles" },
        { label: "吃瓜指南", href: "#guide" },
        { label: "常见问题", href: "#faq" },
        { label: "关于品牌", href: "#about" },
      ],
    },
    {
      title: "更多动态",
      links: [
        { label: "本周高能", href: "#rank" },
        { label: "前往开吃", href: "#archive" },
        { label: "回到顶部", href: "#top" },
      ],
    },
  ];

  return (
    <footer className="bg-secondary-100 text-foreground-900">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-[minmax(0,1.4fr)_1fr_1fr_1fr]">
          <div>
            <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap" aria-label="国产吃瓜 返回顶部">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-film-fill text-xl" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">
                国产<span className="text-primary-600">吃瓜</span>
              </span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-700">
              明星、网红、综艺与剧组的「名场面」与圈子生态图鉴，持续收录，理性又尽兴地陪你吃透每一层瓜。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {["ri-weibo-line", "ri-douban-line", "ri-bilibili-line", "ri-brush-line"].map((c) => (
                <a
                  key={c}
                  href="#top"
                  onClick={(e) => e.preventDefault()}
                  aria-label="关注我们"
                  className="flex h-10 w-10 items-center justify-center rounded-full bg-background-50 text-foreground-600 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={c} aria-hidden="true"></i>
                </a>
              ))}
            </div>
          </div>

          {cols.map((col) => (
            <div key={col.title}>
              <h3 className="font-heading text-base font-bold text-foreground-950">{col.title}</h3>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <a href={l.href} className="text-sm text-foreground-700 transition-colors hover:text-primary-600 whitespace-nowrap">
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-background-200/70 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-600">© 2026 国产吃瓜 · 圈子图鉴 · 仅作娱乐内容分享</p>
          <p className="flex items-center gap-1.5 text-xs text-foreground-600">
            <i className="ri-chat-smile-3-line text-primary-500" aria-hidden="true"></i>
            理性吃瓜，让名场面更长久
          </p>
        </div>
      </div>
    </footer>
  );
}